/**
 * Maps UAT Dashboard clickable elements to the filter config needed to drill
 * through to the release note list. Each entry mirrors the filter object shape
 * used by filterBar.vue / search.vue.
 *
 * NOTE: "application" uses dataType "dynamicDropdown" and requires a numeric ID
 * as the filter value. dashboardServiceArea.vue resolves the chart label (name)
 * to an ID via the admin/dropdown store before navigating, and passes the display
 * label separately as dashboardFilterValueLabel so the filter bar shows the name.
 */
export const DASHBOARD_FILTER_MAP = {
  assignedTo: {
    attributeName: "assignedTo",
    dataType: "user",
    operator: "in",
    valueType: "array",
    attributeNameLabel: "Assigned To",
    operatorLabel: "Includes",
  },
  application: {
    attributeName: "applicationDropdownValueId",
    dataType: "dynamicDropdown",
    operator: "in",
    valueType: "array",
    attributeNameLabel: "Application",
    operatorLabel: "Includes",
  },
  buildType: {
    attributeName: "buildType",
    dataType: "string",
    operator: "in",
    valueType: "array",
    attributeNameLabel: "Build Type",
    operatorLabel: "Includes",
  },
  operationalizeType: {
    attributeName: "operationalizeType",
    dataType: "string",
    operator: "in",
    valueType: "array",
    attributeNameLabel: "Operationalize Type",
    operatorLabel: "Includes",
  },
  releaseType: {
    attributeName: "releaseType",
    dataType: "string",
    operator: "in",
    valueType: "array",
    attributeNameLabel: "Release Type",
    operatorLabel: "Includes",
  },
  status: {
    attributeName: "memberTestPlan.status",
    dataType: "string",
    operator: "in",
    valueType: "array",
    attributeNameLabel: "Testing/Review Status",
    operatorLabel: "Includes",
  },
  userRole: {
    attributeName: "userRole",
    dataType: "string",
    operator: "in",
    valueType: "array",
    attributeNameLabel: "User Role",
    operatorLabel: "Includes",
  },
};
